__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@amzn/awsscm-landing-page";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@amzn/awsscmui-argo-chatbot-component", "0.1.0", () => (Promise.all([__webpack_require__.e(451), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(94451))))));
			register("@amzn/awsui-collection-hooks", "1.0.0", () => (Promise.all([__webpack_require__.e(305), __webpack_require__.e(501), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(6501))))));
			register("@amzn/awsui-components-console", "3.0.0", () => (Promise.all([__webpack_require__.e(305), __webpack_require__.e(67), __webpack_require__.e(241), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(18)]).then(() => (() => (__webpack_require__(31067))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(536).then(() => (() => (__webpack_require__(53536))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(921), __webpack_require__.e(914), __webpack_require__.e(640)]).then(() => (() => (__webpack_require__(95921))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(924).then(() => (() => (__webpack_require__(95924))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(545).then(() => (() => (__webpack_require__(36545))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(736).then(() => (() => (__webpack_require__(38736))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(609).then(() => (() => (__webpack_require__(17609))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(964).then(() => (() => (__webpack_require__(44964))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(509).then(() => (() => (__webpack_require__(56509))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(139).then(() => (() => (__webpack_require__(92139))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(922).then(() => (() => (__webpack_require__(9922))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(954).then(() => (() => (__webpack_require__(11954))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(700).then(() => (() => (__webpack_require__(32700))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(547).then(() => (() => (__webpack_require__(10547))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(619).then(() => (() => (__webpack_require__(36619))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(822).then(() => (() => (__webpack_require__(39822))))));
			register("uuid", "8.3.2", () => (__webpack_require__.e(221).then(() => (() => (__webpack_require__(83221))))));
			register("uuid", "9.0.1", () => (__webpack_require__.e(425).then(() => (() => (__webpack_require__(80425))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};